import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";



export const PRODUCT_ITEM_APIS = {
    uploadFile: (params: any) => postRequest("/file/upload", params),
    createProductItems: (body: any) => postRequest(`/ambassador/add-product`, body),
    getProductItems: (params: any) => getRequest(`/ambassador/products`, params),
    editCupOfGratitudes: (id: number, params: any) => putRequest(`/cup-of-gratitue/${id}`, params),
    getProductItemById: (id: number,) => getRequest(`/ambassador/product/get-by-id/${id}`),
    updateProductItemById: (id: number, body: any) => putRequest(`/ambassador/update-product/${id}`, body),
    updateProductItemStatus: (id: number, body:any) => putRequest(`/ambassador/update-product-status/${id}`, body),
    getOrderRequest: (params: any) => getRequest(`/ambassador/all-product-requests-admin`, params),
    getOrderProductById: (params: any) => getRequest(`/ambassador/product-requests-ambassador`, params),
    createConsigneinfo : (params:any, body:any, ) => putRequest(`/ambassador/update-delivery-information`,params ,body),


    activateMember: (userId: number) => patchRequest(`users/${userId}/enable`, {}),
    deactivateMember: (userId: number) => patchRequest(`users/${userId}/disable`, {}),
};
